
    import $ from 'jquery';
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import Toasted from 'vue-toasted';
    import { KanbanState } from '../../kanban.model';
    import Spinner from '../../../util/Spinner';
    import { handleError } from '../../../../api';
    import { blobDownload,formatDateTimeSeconds } from '../../../../util';

    Vue.use(Toasted, { duration: 2000 });

    @Component({
        name: 'MassSelectPdfConfirmModal',
        components: {
            Spinner,
            vSelect,
        },
    })
    export default class MassSelectPdfConfirmModal extends Vue {
        @Prop({ required: true })
        readonly state!: KanbanState;

        saving: boolean = false;

        public open(): void {
            $(this.$refs.modal!).modal('show');
        }

        public dismiss(): void {
            $(this.$refs.modal!).modal('hide');
        }

        async save(): Promise<void> {
            this.saving = true;
            try {
                if(this.state.massSelectionCards.length>0) {
                    try {
                       // await this.state.cardsAPI.archive(card);
                       console.log(Array.from(this.state.massSelectionCards, (x) =>  x));
                       let ids=Array.from(this.state.massSelectionCards, (x) =>  x.id) as string[];

                        //const file = await this.state.printApi.downloadPdfByCardGuid(card.id);
                        const file = await this.state.printApi.downloadPdfByCardGuids(ids);
                        blobDownload(file.data, file.fileName ?? ('jobs' + '_' + formatDateTimeSeconds(new Date()) + '.pdf'));
                    } catch (e) {
                        handleError(this.$toasted, this.$i18n, e);
                    }
                }
                this.state.massSelectionCards.splice(0);
                this.state.massSelectionEnabled = false;

                this.$toasted.info(this.$t('kanban.massSelect.pdf.confirmModal.done').toString());
                this.dismiss();
            } finally {
                this.saving = false;
            }
        }
    }
